var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRollIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#178477"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2857 24.6715L22.9971 27.383L28.9524 21.4277",
    stroke: "#178477",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2381 35.6918L24 36.3975L22.7619 35.6918C20.1259 34.1698 17.9371 31.9806 16.4157 29.3443C14.8943 26.708 14.094 23.7175 14.0952 20.6737C14.0957 20.2394 14.2103 19.8129 14.4276 19.437C14.6449 19.0611 14.9573 18.7489 15.3333 18.5318L22.8609 14.186C23.2068 13.9849 23.5998 13.8789 24 13.8789C24.4001 13.8789 24.7931 13.9849 25.139 14.186L32.6666 18.5318C33.0427 18.7489 33.3551 19.0611 33.5724 19.437C33.7897 19.8129 33.9043 20.2394 33.9047 20.6737C33.906 23.7175 33.1056 26.708 31.5843 29.3443C30.0629 31.9806 27.8741 34.1698 25.2381 35.6918Z",
    stroke: "#178477",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollIconWhite);
export default __webpack_public_path__ + "static/media/Roll-icon-white.c516ad16023714f2d7d20ddc4c44904e.svg";
export { ForwardRef as ReactComponent };